import { render, staticRenderFns } from "./ModalPositionDetails.vue?vue&type=template&id=6459ba30&"
import script from "./ModalPositionDetails.vue?vue&type=script&lang=js&"
export * from "./ModalPositionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalPositionDetails.vue?vue&type=style&index=0&id=6459ba30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports